<template>
  <div
    :class="`${containerClasses || ''} ${warning ? 'has-warning' : ''} ${errorToForceUntilIsDirty && !isDirty ? 'has-error' : ''}`"
  >
    <label
      v-if="type !== 'radio' && hasLabel"
      class="control-label bottom-offset1"
    >
      <slot name="label">
        {{ label }}
      </slot>
    </label>
    <div
      v-if="select"
      class="select-container"
    >
      <select
        ref="input"
        :required="required"
        :name="name"
        :placeholder="placeholder"
        :value="modelValue"
        class="form-control"
        @input="updateValue($event.target.value)"
      >
        <slot />
      </select>
      <tr-svg-icon
        class="select-dropdown-icon"
        size="small"
        name="ic-arrow-dropdown"
        color="grey"
      />
    </div>
    <img
      v-if="radioImgSrc"
      :src="radioImgSrc"
      :class="`cursor-pointer bottom-offset2 ic--${radioImgSize || 'medium'}`"
      @click="updateValue(radioValue)"
    >
    <input
      v-if="type === 'radio'"
      ref="input"
      type="radio"
      :disabled="shouldDisable"
      :required="required"
      :name="name"
      :checked="modelValue === radioValue"
      :value="radioValue"
    >
    <label
      v-if="type === 'radio'"
      class="control-label"
      :class="`${shouldDisable ? 'disabled' : ''}`"
      @click="updateValue(radioValue)"
    >
      <slot name="label" />
      {{ label }}
    </label>
    <div :class="addonContent ? 'input-group' : ''">
      <span
        v-if="addonContent"
        class="input-group-addon"
      >
        {{ addonContent }}
      </span>
      <input
        v-if="!select && type !== 'radio' && type !== 'textarea'"
        ref="input"
        :autofocus="autofocus"
        :type="type && type !== 'date' ? type : 'text'"
        :class="`form-control ${inputClasses || ''} ${inputSearch ? 'input-search' : ''} ${SIZE[size]} ${!hideCalendarIcon && type === 'date' ? 'input-datepicker' : ''}`"
        :disabled="shouldDisable"
        :required="required"
        autocomplete="off"
        :readonly="readonly"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :name="name"
        :value="internalValue"
        @input="updateValue($event.target.value)"
        @blur="onBlur ? onBlur() : null"
      >
    </div>
    <textarea
      v-if="type === 'textarea'"
      ref="input"
      class="form-control"
      :disabled="shouldDisable"
      :placeholder="placeholder"
      :required="required"
      :pattern="formattedPattern"
      :maxlength="maxlength"
      :name="name"
      :value="modelValue"
      @input="updateValue($event.target.value)"
      @blur="onBlur ? onBlur() : null"
    />
    <div
      v-if="!isValid && !(errorToForceUntilIsDirty && !isDirty)"
      class="invalid-feedback"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery';
import { input as inputMixin } from '../mixins';
import masks from '../constants/masks';
import { regexes } from '@transfeeradev/api-enums';
import Inputmask from 'inputmask';
import moment from '@transfeeradev/moment';

const IS_DATE_ALREADY_FORMATED_REGEX = /^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/;

export default {
  name: 'TrTextField',
  mixins: [inputMixin],
  props: [
    'type',
    'placeholder',
    'select',
    'radioValue',
    'inputSearch',
    'pattern',
    'maskFormat',
    'maxlength',
    'exactLength',
    'hideCalendarIcon',
    'datepickerOrientation',
    'radioImgSrc',
    'radioImgSize'
  ],
  data: () => ({
    lastInternalValue: 0,
    formattedPattern: null,
    maskFormatToBeRendered: undefined
  }),
  computed: {
    internalValue() {
      if (this.type === 'date') {
        if (this.modelValue && !IS_DATE_ALREADY_FORMATED_REGEX.test(this.modelValue) && moment(this.modelValue).isValid()) {
          let dateValue = this.modelValue;
          try {
            dateValue = moment(this.modelValue).format('DD/MM/YYYY');
            const $input = jQuery(this.$el.querySelector('input'));
            $input.datepicker('setDate', dateValue);
            return dateValue;
          } catch (e) {
            return dateValue;
          }
        }
        return this.modelValue;
      }
      return this.modelValue;
    },
  },
  watch: {
    maxlength() {
      this.forceValidation();
    },
    pattern() {
      this.forceValidation();
    }
  },
  created() {
    let pattern = this.pattern;

    this.maskFormatToBeRendered = this.maskFormat;
    if (this.type === 'date' && !this.maskFormat) {
      this.maskFormatToBeRendered = masks.DATE;

      if (!pattern) {
        pattern = regexes.DATE;
      }
    }

    if (this.type === 'currency' && !this.maskFormat) {
      this.maskFormatToBeRendered = masks.CURRENCY;
    }

    if (pattern && pattern.test) {
      this.formattedPattern = _removeCharToMakeRegexWorkOnInput(pattern);
    } else {
      this.formattedPattern = pattern;
    }
  },
  mounted() {
    const $input = this.getInput();
    if ($input) {
      $input.vueInstance = this;
    }

    if (this.maskFormatToBeRendered) {
      Inputmask(this.maskFormatToBeRendered).mask($input);
    }

    if (this.type === 'date') {
      _createDatePicker(this.$el, this.updateValue, this.datepickerOrientation);
    }
  },
  methods: {
    _getFormattedValue(value) {
      return Number.parseFloat(String(value).replace(',', '.'));
    }
  }
};

const _removeCharToMakeRegexWorkOnInput = regex => {
  const CHAR_TO_BE_REMOVED = '/';
  return String(regex).replace(new RegExp(CHAR_TO_BE_REMOVED, 'g'), '');
};

const _createDatePicker = ($element, onValueChange, orientation) => {
  const options = {
    format: 'dd/mm/yyyy',
    autoclose: true,
    orientation: orientation || 'auto',
    container: $element,
    language: 'pt-BR',
    todayHighlight: true
  };
  const $input = jQuery($element.querySelector('input'));
  const datePicker = $input.datepicker(options);
  datePicker.on('changeDate', () => {
    onValueChange($input.val());
  });
}
</script>
